export var ACTIVE_HEADER_TYPE = 'active-header';
export var AREA_TYPE = 'area';
export var CELL_TYPE = 'cell';
export var FILL_TYPE = 'fill';
export var HEADER_TYPE = 'header';
export var CUSTOM_SELECTION_TYPE = 'custom-selection';


//////////////////
// WEBPACK FOOTER
// ./~/handsontable/selection/highlight/constants.mjs
// module id = 118
// module chunks = 1